import BaseLayout from "./Layout";
export default BaseLayout;
